<template>
  <div class="index" v-loading="loading">
    <div class="index-con">
      <div class="con-info">
        <div class="con-info-title">会议信息</div>
        <div class="con-info-lists">
          <div class="con-info-list-title">
            <span>·</span>2024国际食品生物科学与食品营养会议
          </div>
          <div class="con-info-list">
            <span>·</span> <b> 会议时间:</b> 2024年12月3-6日
          </div>
          <div class="con-info-list">
            <span>·</span> <b>地点:</b>世界酒店Grand Juna无锡，无锡，中国
          </div>
        </div>
      </div>
      <div class="paper-info">
        <div class="con-info-title">纸张信息</div>
        <div class="paper-info-con">
          <div class="paper-info-title">作者信息</div>
          <div class="tip">
            电子邮件地址将仅用于与作者沟通，通联系人将收到来自系统的关于此次提交的电子邮件，至少应标记一名通联系人。
          </div>

          <div class="sub-type">
            <p>姓名:*</p>
            <input type="text" maxlength="200" v-model="name" />
          </div>
          <div class="sub-type">
            <p>城市:*</p>
            <input type="text" maxlength="200" v-model="country" />
          </div>
          <div class="sub-type">
            <p>工作单位:*</p>
            <input type="text" maxlength="200" v-model="affiliation" />
          </div>
          <div class="sub-type">
            <p>地址:*</p>
            <input type="text" maxlength="200" v-model="address" />
          </div>
          <div class="sub-type">
            <p>邮件:*</p>
            <input type="text" maxlength="200" v-model="email" />
          </div>
          <div class="sub-type">
            <p>传真:*</p>
            <input type="text" maxlength="200" v-model="fax" />
          </div>
          <div class="sub-type">
            <p>关于:</p>
            <textarea placeholder="Special instructions" v-model="about" cols="30" rows="10"
              maxlength="1000000"></textarea>
          </div>

          <div class="yellow-tip">
            如果您已经填写了表格，请按下面的“提交”按钮。上传可能需要一段时间，请不要点击两次按钮。
          </div>
          <div class="sub-mit" @click="tosubUpThen">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      host: "/api",
      loading: false,
      radios: 0,

      submissionType: "1",
      title: "",
      abstract: "",
      keywords: "",
      visitor_id: "",
      report_url: "",
      radio: 0,
      id: "",
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.visitor_id = localStorage.getItem("visitor_id");
    if (!token) {
      this.$router.push("/login");
      return;
    }
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      var params = {
        report_id: this.id,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.report_list(params).then((res) => {
        loading.close();
        if (res.code == 200) {
          var con = res.data[0];
          var len = con.file_url.split("/").length;
          that.fileList = [
            { name: con.file_url.split("/")[len - 1], url: con.file_url },
          ];
          that.title = con.title;
          that.submissionType = con.submissionType.toString();
          that.abstract = con.abstract;
          that.keywords = con.keywords;
          that.report_url = con.file_url;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    onexceedFn(a, b) { },
    successReport(a) {
      this.report_url = a.data;
      console.log(a.data, "-=-=-=-=");
      this.loading = false;
    },
    removeReport(a) {
      if (a.response && a.response.data) {
        for (var i = 0; i < this.report_url.length; i++) {
          if (this.report_url[i] == a.response.data) {
            this.report_url.splice(i, 1);
          }
        }
      }
      console.log(this.report_url);
    },
    beforeAvatarUpload(rawFile) {
      console.log(rawFile);
      if (rawFile.size > 1024 * 1024 * 200) {
        this.$message({
          message: "文件不能超过200M",
          type: "error",
        });
        return false;
      } else {
        this.loading = true;
        return true;
      }
    },
    tosubUpThen() {
      if (!this.name) {
        this.$message.error("请输入名字");
        return;
      }
      if (!this.country) {
        this.$message.error("请填写国家");
        return;
      }
      if (!this.affiliation) {
        this.$message.error("请填写工作单位");
        return;
      }
      if (!this.address) {
        this.$message.error("请输入地址");
        return;
      }
      if (!this.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      var params = {
        name: this.name,
        country: this.country,
        affiliation: this.affiliation,
        address: this.address,
        email: this.email,
        fax: this.fax,
        about: this.about,
        visitor_id: this.visitor_id,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.id) {
        // 修改
        params.report_id = this.id;
        this.$http.upload_report(params).then((res) => {
          loading.close();
          if (res.code == 200) {
            that.$message.success("提交成功");
            setTimeout(() => {
              that.$router.push("/loginThen");
            }, 200);
          } else {
            that.$message.error(res.msg);
          }
        });
      } else {
        // 添加
        this.$http.add_report(params).then((res) => {
          loading.close();
          if (res.code == 200) {
            that.$message.success("提交成功");
            setTimeout(() => {
              that.$router.push("/loginThen");
            }, 200);
          } else {
            that.$message.error(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.index-con {
  margin: 0 auto;
  width: 1200px;
  padding: 20px;
  box-sizing: border-box;
}

.con-info,
.paper-info {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.con-info-title {
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
}

.con-info-lists {
  padding: 20px;
  box-sizing: border-box;
}

.con-info-lists span {
  font-size: 24px;
  font-weight: 500;
}

.con-info-list-title {
  font-weight: 600;
  font-size: 18px;
}

.paper-info-con {
  padding: 20px;
  box-sizing: border-box;
}

.paper-info-title {
  font-size: 16px;
  font-weight: 600;
  padding: 15px 0;
  box-sizing: border-box;
}

.tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.author {
  color: #31708f;
  font-weight: 600;
  margin-bottom: 15px;
}

.author span {
  color: #f00;
}

.author-lists {
  display: flex;
  flex-wrap: wrap;
}

.delete-btn {
  padding: 8px 25px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  background: #f00;
}

.author-list {
  width: calc(25% - 20px);
  margin-right: 20px;
  margin-bottom: 20px;
}

.author-list:nth-of-type(4n) {
  margin-right: 0;
}

.author-list p {
  font-weight: 600;
  margin-bottom: 4px;
}

.author-list input,
.sub-type input {
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-left: 15px;
  box-sizing: border-box;
}

.my-select {
  border-radius: 4px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 15px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.author-btn {
  display: inline-block;
  padding: 8px 20px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 20px;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.sub-type {
  margin-bottom: 20px;
}

.sub-type p {
  margin-bottom: 5px;
  font-weight: 600;
}

.sub-type textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.upload-btn {
  margin-top: 20px;
  margin-bottom: 20px;
}

.yellow-tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #8a6d3b;
  margin-top: 20px;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.sub-mit {
  width: auto;
  display: inline-block;
  padding: 10px 46px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
}

.w-100 {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .author-lists {
    display: block;
  }

  .author-list {
    width: 100%;
    margin: 20px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/submissRegistrationzh.vue